/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

jQuery(function ($) {
	const header = $("header.wp-block-template-part");
	const body = $("body");

	const $menuPart1 = $(".menu-part-1");
	const $menuPart2 = $(".menu-part-2");
	const $lienFormations = $(".click-retour");

	function calcHeaderHeight() {
		const height = header.find("> .wp-block-group").outerHeight();
		document.documentElement.style.setProperty(
			"--header-height",
			height + "px",
		);
	}

	function toggleBurgerMenu() {
		$(".burger").toggleClass("open");
		$(".sub-menu").hide();

		// bloque le scroll de la page quand le menu mobile est ouvert
		body.css("overflow", body.css("overflow") === "hidden" ? "auto" : "hidden");

		let menuContainer = $(".menu-wrapper");

		header.append(menuContainer);

		menuContainer.find(".menu-item-has-children a").addClass("has-submenu");
		menuContainer.slideToggle();
	}

	function handleSubmenuClick(e) {
		const $this = $(this);
		const $submenu = $this.next(".sub-menu");

		if ($this.data("clicked")) return true;

		e.preventDefault();
		$submenu.slideToggle(400, function () {
			if ($(this).is(":visible")) $(this).css("display", "flex");
		});

		$this.data("clicked", true);
		$(document).one("click", () => $this.data("clicked", false));
	}

	function insertClasseMenu() {
		const firstLi = $(".menu-principal").children().first();
		console.log("zeubi");
		firstLi.addClass("is-hidden");

		const firstLiFormations = firstLi.children().first();
		firstLiFormations.addClass("toggle-formations");
		firstLiFormations.append(' <i class="fa-solid fa-angle-right"></i>');
	}

	function handleClickFormations(e) {
		e.preventDefault();

		if ($lienFormations.hasClass("is-hidden")) {
			$lienFormations.removeClass("is-hidden").addClass("is-visible");
		} else {
			$lienFormations.removeClass("is-visible").addClass("is-hidden");
		}

		$menuPart1.toggle();
		$menuPart2.toggle();
	}

	function removeCSS() {
		if (window.innerWidth >= 1025) {
			$lienFormations.addClass("is-hidden").removeClass("is-visible");

			$menuPart1.each(function () {
				this.style.removeProperty("display");
			});

			$menuPart2.each(function () {
				this.style.removeProperty("display");
			});
			console.log("issou");
		}
	}

	$(window).on("load resize", calcHeaderHeight, removeCSS);
	$(".burger").on("click", toggleBurgerMenu);
	$(document).on("click", ".has-submenu", handleSubmenuClick);
	$(document).on("click", ".toggle-formations", handleClickFormations);
	$(document).ready(insertClasseMenu);
});
